import { IColumnSortingInfo } from 'types/table';

export enum ColumnSorting {
  Asc = 'asc',
  Desc = 'desc',
}

export const getColumnSorting = (sortBy: string | null) => {
  switch (sortBy) {
    case ColumnSorting.Asc:
      return ColumnSorting.Desc;
    case ColumnSorting.Desc:
      return null;
    default:
      return ColumnSorting.Asc;
  }
};

export const getColumnsSorting = (defaultColumnsSorting: IColumnSortingInfo[], sort?: string | string[]) => {
  const [id, sortBy] = sort ? String(sort).split(':') : [];

  return defaultColumnsSorting?.map((sortingInfo) =>
    sortingInfo.id === id ? { id, sortBy } : { ...sortingInfo, sortBy: null },
  );
};
